import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ColorIntensityContextType {
  intensity: number;
  setIntensity: (intensity: number) => void;
  calendarZoom: number;
  setCalendarZoom: (zoom: number) => void;
}

const ColorIntensityContext = createContext<ColorIntensityContextType | undefined>(undefined);

export const useColorIntensity = () => {
  const context = useContext(ColorIntensityContext);
  if (context === undefined) {
    throw new Error('useColorIntensity must be used within a ColorIntensityProvider');
  }
  return context;
};

interface ColorIntensityProviderProps {
  children: ReactNode;
}

export const ColorIntensityProvider: React.FC<ColorIntensityProviderProps> = ({ children }) => {
  const [intensity, setIntensity] = useState<number>(1.0); // Default to full intensity
  const [calendarZoom, setCalendarZoom] = useState<number>(0.9); // Default to 90% zoom

  const handleSetIntensity = (newIntensity: number) => {
    console.log('Setting color intensity to:', newIntensity);
    setIntensity(newIntensity);
  };

  const handleSetCalendarZoom = (newZoom: number) => {
    console.log('Setting calendar zoom to:', newZoom);
    setCalendarZoom(newZoom);
  };

  const value = {
    intensity,
    setIntensity: handleSetIntensity,
    calendarZoom,
    setCalendarZoom: handleSetCalendarZoom,
  };

  return (
    <ColorIntensityContext.Provider value={value}>
      {children}
    </ColorIntensityContext.Provider>
  );
};